import constants from '@/app-configs/constants'

export default [
  {
    path: '/orders',
    name: 'orders',
    component: () => import('@/views/orders/Orders.vue'),
    meta: {
      pageTitle: 'DEBTIA_ORDERS',
      breadcrumb: [
        {
          text: 'DEBTIA_ORDERS',
          active: true,
        },
      ],
      action: constants.action.permissionOrdersList,
      resource: constants.resource.user,
    },
  },
  {
    path: '/order/details/:id',
    name: 'order-details',
    component: () => import('@/views/orders/OrderDetails.vue'),
    meta: {
      action: constants.action.permissionOrdersList,
      resource: constants.resource.user,
    },
  },
]
